import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../../assets/common/nyoni_white.png';
import _imports_1 from '../../assets/products/catalog/color_pencil.jpg';
import _imports_2 from '../../assets/products/catalog/sketch_pencil.jpg';
import _imports_3 from '../../assets/products/catalog/charcoal_pencil.jpg';
import _imports_4 from '../../assets/products/catalog/school_office_pencil.jpg';
import _imports_5 from '../../assets/products/catalog/eraser.jpg';
import _imports_6 from '../../assets/products/catalog/other_tools.jpg';
const _hoisted_1 = {
  class: "portfolio-list"
};
const _hoisted_2 = {
  class: "short-content"
};
const _hoisted_3 = {
  class: "row items"
};
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"p-img\"><div class=\"logo\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><img class=\"colored animateRight\" src=\"" + _imports_1 + "\" alt=\"\"><img class=\"grey animateRight\" src=\"" + _imports_1 + "\" alt=\"\"></div>", 1);
const _hoisted_5 = {
  class: "p-text animateFadeIn"
};
const _hoisted_6 = {
  class: "h3-static"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "NYONI - Define Your Direction Of Art", -1);
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"p-img\"><div class=\"logo\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><img class=\"colored animateRight\" src=\"" + _imports_2 + "\" alt=\"\"><img class=\"grey animateRight\" src=\"" + _imports_2 + "\" alt=\"\"></div>", 1);
const _hoisted_9 = {
  class: "p-text animateFadeIn"
};
const _hoisted_10 = {
  class: "h3-static"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "NYONI - Define Your Direction Of Art", -1);
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"p-img\"><div class=\"logo\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><img class=\"colored animateRight\" src=\"" + _imports_3 + "\" alt=\"\"><img class=\"grey animateRight\" src=\"" + _imports_3 + "\" alt=\"\"></div>", 1);
const _hoisted_13 = {
  class: "p-text animateFadeIn"
};
const _hoisted_14 = {
  class: "h3-static"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "NYONI - Define Your Direction Of Art", -1);
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"p-img\"><div class=\"logo\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><img class=\"colored animateRight\" src=\"" + _imports_4 + "\" alt=\"\"><img class=\"grey animateRight\" src=\"" + _imports_4 + "\" alt=\"\"></div>", 1);
const _hoisted_17 = {
  class: "p-text animateFadeIn"
};
const _hoisted_18 = {
  class: "h3-static"
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "NYONI - Define Your Direction Of Art", -1);
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"p-img\"><div class=\"logo\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><img class=\"colored animateRight\" src=\"" + _imports_5 + "\" alt=\"\"><img class=\"grey animateRight\" src=\"" + _imports_5 + "\" alt=\"\"></div>", 1);
const _hoisted_21 = {
  class: "p-text animateFadeIn"
};
const _hoisted_22 = {
  class: "h3-static"
};
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "NYONI - Define Your Direction Of Art", -1);
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"p-img\"><div class=\"logo\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><img class=\"colored animateRight\" src=\"" + _imports_6 + "\" alt=\"\"><img class=\"grey animateRight\" src=\"" + _imports_6 + "\" alt=\"\"></div>", 1);
const _hoisted_25 = {
  class: "p-text animateFadeIn"
};
const _hoisted_26 = {
  class: "h3-static"
};
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, "NYONI - Define Your Direction Of Art", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("home.productsList.title")), 1), _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("home.productsList.content")), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("a", {
    href: "javaScript:void(0)",
    class: "col-12 col-sm-6 p-item animateFadeIn",
    onClick: _cache[0] || (_cache[0] = $event => $options.toProducts('color_pencil'))
  }, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("common.productsCategory.color_pencil")), 1), _hoisted_7])]), _createElementVNode("a", {
    href: "javaScript:void(0)",
    class: "col-12 col-sm-6 p-item animateFadeIn",
    onClick: _cache[1] || (_cache[1] = $event => $options.toProducts('sketch_pencil'))
  }, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("common.productsCategory.sketch_pencil")), 1), _hoisted_11])]), _createElementVNode("a", {
    href: "javaScript:void(0)",
    class: "col-12 col-sm-6 p-item animateFadeIn",
    onClick: _cache[2] || (_cache[2] = $event => $options.toProducts('charcoal_pencil'))
  }, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t("common.productsCategory.charcoal_pencil")), 1), _hoisted_15])]), $data.routerName != 'nyoni' ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    href: "javaScript:void(0)",
    class: "col-12 col-sm-6 p-item animateFadeIn",
    onClick: _cache[3] || (_cache[3] = $event => $options.toProducts('school_office_pencil'))
  }, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t("common.productsCategory.school_office_pencil")), 1), _hoisted_19])])) : _createCommentVNode("", true), _createElementVNode("a", {
    href: "javaScript:void(0)",
    class: "col-12 col-sm-6 p-item animateFadeIn",
    onClick: _cache[4] || (_cache[4] = $event => $options.toProducts('eraser'))
  }, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.$t("common.productsCategory.eraser")), 1), _hoisted_23])]), _createElementVNode("a", {
    href: "javaScript:void(0)",
    class: "col-12 col-sm-6 p-item animateFadeIn",
    onClick: _cache[5] || (_cache[5] = $event => $options.toProducts('other_tools'))
  }, [_hoisted_24, _createElementVNode("div", _hoisted_25, [_createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t("common.productsCategory.other_tools")), 1), _hoisted_27])])])]);
}